var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import capitalize from "@material-ui/core/utils/capitalize";
import { Box } from "../box";
import { Logo } from "../logo";
import { fade, makeStyles } from "../styles";
import clsx from "../utils/clsx";
export var SpinnerComponentName = "CosmosSpinner";
export var useSpinnerStyles = makeStyles(function (theme) {
    return {
        "@keyframes rotate": {
            "0%": { transform: "rotate(0deg)" },
            "100%": { transform: "rotate(1turn)" },
        },
        root: {
            position: "relative",
            height: theme.typography.pxToRem(40),
            width: theme.typography.pxToRem(40),
            "& $spinner": {
                height: theme.typography.pxToRem(40),
                width: theme.typography.pxToRem(40),
            },
        },
        spinner: {
            display: "inline-block",
            border: "2px solid",
            borderColor: fade(theme.palette.common.black, 0.08),
            borderLeftColor: fade(theme.palette.common.black, 0.4),
            borderRadius: "50%",
            verticalAlign: "text-bottom",
            animation: "$rotate 0.8s infinite linear",
        },
        inverse: {
            borderColor: fade(theme.palette.common.white, 0.2),
            borderLeftColor: fade(theme.palette.common.white, 0.85),
        },
        logo: {
            position: "absolute",
            top: "52%",
            left: "50%",
            transform: "translate(-50%, -50%)",
        },
        sizeSmall: {
            height: theme.typography.pxToRem(14),
            width: theme.typography.pxToRem(14),
            "& $spinner": {
                height: theme.typography.pxToRem(14),
                width: theme.typography.pxToRem(14),
            },
        },
        sizeLarge: {
            height: theme.typography.pxToRem(60),
            width: theme.typography.pxToRem(60),
            "& $spinner": {
                height: theme.typography.pxToRem(60),
                width: theme.typography.pxToRem(60),
            },
        },
    };
}, { name: SpinnerComponentName });
export var Spinner = React.forwardRef(function (props, ref) {
    var classes = useSpinnerStyles(props);
    var className = props.className, _a = props.size, size = _a === void 0 ? "small" : _a, _b = props.inverse, inverse = _b === void 0 ? false : _b, propClasses = props.classes, _c = props.LogoProps, LogoProps = _c === void 0 ? {} : _c, rootProps = __rest(props, ["className", "size", "inverse", "classes", "LogoProps"]);
    var sizeClass = size && classes["size" + capitalize(size)];
    if (size === "small") {
        return (React.createElement(Box, __assign({}, { ref: ref }, { className: clsx(classes.root, classes.spinner, sizeClass, inverse && classes.inverse, className) }, rootProps)));
    }
    return (React.createElement(Box, __assign({}, { ref: ref }, { className: clsx(classes.root, sizeClass, className) }),
        React.createElement(Box, { className: clsx(classes.spinner, inverse && classes.inverse) }),
        React.createElement(Logo, __assign({ className: classes.logo, size: size === "medium" ? "xsmall" : "small", color: inverse ? "light" : "dark" }, LogoProps))));
});
